export default (to, from, next) => {
  if (localStorage.getItem('QBKAdmin') != null && localStorage.getItem('QBKAdmin').length > 0) {
    next()
  } else {
    localStorage.removeItem('QBKAdmin')
    next('/login')
  }
}
